import { experimentalStyled } from '@material-ui/core/styles';


const CashByCreativeLogo = (props) => (
  <img src="/static/CashByCreativeLogo.png" width={props.width} />
);

export default CashByCreativeLogo;
